/*                                                 *\
** ----------------------------------------------- **
**          Calliope - Pixos Game Engine   	       **
** ----------------------------------------------- **
**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **
**                                                 **
**    Any unauthorized distribution or transfer    **
**       of this work is strictly prohibited.      **
**                                                 **
**               All Rights Reserved.              **
** ----------------------------------------------- **
\*                                                 */

import pixosEngine from "pixos-engine";
let Modules = pixosEngine['pixos-engine'].Modules;

let Portal = Modules.sprites.furniture.portal;
export default class MyPortal extends Portal {
  constructor(engine) {
    // Initialize Sprite
    super(engine);
  }
}
